import styled from 'styled-components';
import { cloudinaryUrl } from 'services/cloudinary';
import Text, { TypeVariant } from 'shared/Typography';
import { buildImageUrl } from 'cloudinary-build-url';
import { RESIZE_TYPES } from '@cld-apis/utils';
import Image from 'next/image';

export const ImageWrapper = styled.div`
  /* margin-top: 120px;
  margin-left: 30px; */
  flex: 1;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    display: none;
  } ;
`;

export const Container = styled.div<{ bgImage: string }>`
  display: flex;
  gap: var(--spacing-80);
  padding: 0 74px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    justify-content: center;
    background-image: ${({ bgImage }) => `url("${bgImage}")`};
    background-size: contain;
    background-position: -50px 1px;
    background-repeat: no-repeat;
    padding: 0;
    margin-top: 110px;
    margin-bottom: 50px;
  } ;
`;

export const SectionTwoRightCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--color-white);

  @media ${(p) => p.theme.queries.tabletAndDown} {
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
  } ;
`;

export const TitleWrap = styled.div`
  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-top: 40px;
    max-width: 570px;
    padding: 0 20px;
  }

  @media ${(p) => p.theme.queries.phoneAndDown} {
    max-width: 375px;
  } ;
`;

export const DescriptionWrap = styled.div`
  padding-top: 30px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding-left: 20px;
    padding-right: 20px;
    max-width: 500px;
  } ;
`;

const bgImage = cloudinaryUrl('Samantha4-removebg_1_j6nhyk', 'auto', false);

const SectionTwo = () => {
  const imageUrl = buildImageUrl('Samantha4-removebg_1_j6nhyk', {
    transformations: {
      resize: {
        type: RESIZE_TYPES.SCALE,
        width: 550,
        height: 880,
      },
      quality: 100,
    },
  });
  return (
    <Container bgImage={bgImage}>
      <ImageWrapper>
        <Image src={imageUrl} width={550} height={880} />
      </ImageWrapper>
      <SectionTwoRightCol>
        <TitleWrap>
          <Text
            variant={TypeVariant.header02}
            as="h2"
            tablet={TypeVariant.subtitle01}
            phone={TypeVariant.subtitle01}
            textAlign="center"
          >
            Tools, support & monetization to make you a fitness mogul
          </Text>
        </TitleWrap>
        <DescriptionWrap>
          <Text
            variant={TypeVariant.bodyLarge01}
            tablet={TypeVariant.body01}
            as="p"
            textAlign="center"
          >
            Once you create content that people love, we offer the best tools to
            monetize and engage your community
          </Text>
        </DescriptionWrap>
      </SectionTwoRightCol>
    </Container>
  );
};

export default SectionTwo;
